<template>
  <BContainer
    fluid
  >
    <router-view />
  </BContainer>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { core } from '@/config/pluginInit'

export default {
  name: 'AuthorizationLayout',
  computed: {
    ...mapGetters({
      darkMode: 'settings/darkModeState'
    })
  },
  mounted () {
    core.index()
    core.mainIndex()
    this.modeChange({ rtl: false, dark: this.darkMode })
  },
  destroyed () {
    document.body.classList = ''
  },
  methods: {
    ...mapActions({
      modeChange: 'settings/layoutModeAction'
    })
  }
}
</script>
